import React from "react";
import { useNavigate } from "react-router-dom";
import "../home/Home.css";
import Header from "../header/header";
import Blog from "../blog/Blog";
import Footer from "../footer/footer";
import Dailyhoro from "../horoscope/horoscope";
import Banner from "./banner";
import Baner from "./baner";
import Banneer from "./banneer";
import HomeOverlay from "./HomeOverlay";
import SEO from "../../common/SEO";             
import SEOConfig from "../../common/SEOConfig";
import AstrologerSlider from "./AstrologerSlider";
import ConsultSection from "./ConsultSection";
import AstroTipsSection from "./AstroTipsSection";
import PromoBanner from "./PromoBanner";
// import AppDownloadOverlay from "../astrologerverification/AppDownloadOverlay";
const App = () => {
  const navigate = useNavigate();

  const handleCallNow = () => {
    navigate("/call-with-astrologer");
  };

  const handleChatNow = () => {
    navigate("/chat-with-astrologer");
  };

  return (
    <div>
      <SEO config={SEOConfig.home} />
      <Header />

{/* <AppDownloadOverlay /> */}
      <div className="home-container mt-5">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 position-relative">
            {/* <video
              className="img-responsive"
              src={require("../../assets/video.mp4")}
              // src={require("../../assets/image.webp")}
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
              style={{ width: "100%", objectFit: "cover" }}
            /> */}
            {/* <img
  className="img-responsive"
  src={require("../../assets/hero section bannerrrr.webp")}
  alt="AstroBhagya Banner"
  style={{ width: "100%", objectFit: "cover", display: "block" }}
/> */}
<img
  className="img-responsive"
  src={require("../../assets/hero section bannerrrr.webp")}
  alt="AstroBhagya Banner"
  style={{
    width: "100%",
    height: "580px",
    objectFit: "cover",
    display: "block",
    // borderRadius: "20px",
  }}
/>
            <HomeOverlay />
            <div className="text-overlay">
              {/* <h3 className="font-weight-bold text-white">
                Step into a world of answers with AstroBhagya
              </h3> */}
              {/* <h3 className="font-weight-bold text-white">
  <span style={{color: '#fff'}}>Step into a world of </span>
  <span style={{color: '#ff4d94'}}>answers</span>
  <span style={{color: '#fff'}}> with </span>
  <span>AstroBhagya</span>
</h3>
              <p className="text-white">
                Our expert astrologers provide bespoke guidance for love,
                career, and life challenges, helping you take confident steps
                forward. Contact us today for personalised insights that
                illuminate your path.
              </p> */}
              <h1 className="font-weight-bold text-white"
              style={{
                fontSize: "48px",
                lineHeight: "1.2",
                fontWeight: "700",
                maxWidth: "700px",
              }}>
              Step into a world of{" "}
              <span style={{ color: "#d4af37" }}>answers</span> with AstroBhagya</h1>

              <p className="text-white"
              style={{
                fontSize: "19px",
                lineHeight: "1.7",
                maxWidth: "650px",
              }}>
              Our expert astrologers provide bespoke guidance for love,
              career, and life challenges, helping you take confident steps
              forward. Contact us today for personalised insights that
              illuminate your path.</p>
              {/* <div className="button-group">
                <button className="btns btn-lights" onClick={handleCallNow}>
                  Call with Astrologer
                </button>
                <button className="btns btn-lights" onClick={handleChatNow}>
                  Chat with Astrologer
                </button>
              </div> */}
              <div className="button-group">
            <button
              className="btns"
              onClick={handleCallNow}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#a11d58";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#89184a";
              }}
              style={{
                backgroundColor: "#89184a",
                color: "#fff",
                border: "1px solid rgba(255,255,255,0.1)",
                borderRadius: "12px",
                boxShadow: "0 10px 25px rgba(0,0,0,0.25)",
                transition: "0.3s ease",
              }}
            >
              Call with Astrologer
            </button>

            <button
              className="btns"
              onClick={handleChatNow}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#f8d7e5";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#ffffff";
              }}
              style={{
                backgroundColor: "#fff",
                color: "#89184a",
                border: "none",
                borderRadius: "12px",
                boxShadow: "0 10px 25px rgba(0,0,0,0.25)",
                transition: "0.3s ease",
              }}
            >
              Chat with Astrologer
            </button>
          </div>
            </div>
          </div>
        </div>
      </div>
     
<AstrologerSlider />
   <ConsultSection />
      {/* <div className="row justify-content-center">
        <div className="horotitle">
          <h2>FREE DAILY HOROSCOPE</h2>
        </div>
        <div className="col-12 col-md-12 ">
          <div className="zodiac-container">
            <div className="zodiac-icons">
              {[
                {
                  src: require("../../assets/Ariesss.webp"),
                  alt: "Aries",
                  sign: "ARIES",
                  path: "/daily-horoscopeari",
                },
                {
                  src: require("../../assets/Taurusss.webp"),
                  alt: "Taurus",
                  sign: "TAURUS",
                  path: "/daily-horoscopetau",
                },

                {
                  src: require("../../assets/Geminiii.webp"),
                  alt: "Gemini",
                  sign: "GEMINI",
                  path: "/daily-horoscopegem",
                },
                {
                  src: require("../../assets/Cancerrr.webp"),
                  alt: "Cancer",
                  sign: "CANCER",
                  path: "/daily-horoscopecan",
                },
                {
                  src: require("../../assets/Leooo.webp"),
                  alt: "Leo",
                  sign: "LEO",
                  path: "/daily-horoscopeleo",
                },
                {
                  src: require("../../assets/Virgooo.webp"),
                  alt: "Virgo",
                  sign: "VIRGO",
                  path: "/daily-horoscopevir",
                },
                {
                  src: require("../../assets/Libraaa.webp"),
                  alt: "Libra",
                  sign: "LIBRA",
                  path: "/daily-horoscopelib",
                },
                {
                  src: require("../../assets/Scorpiooo.webp"),
                  alt: "Scorpio",
                  sign: "SCORPIO",
                  path: "/daily-horoscopesco",
                },
                {
                  src: require("../../assets/Sagittariusss.webp"),
                  alt: "Sagittarius",
                  sign: "SAGITTARIUS",
                  path: "/daily-horoscopesag",
                },
                {
                  src: require("../../assets/Capricornnn.webp"),
                  alt: "Capricorn",
                  sign: "CAPRICORN",
                  path: "/daily-horoscopecap",
                },
                {
                  src: require("../../assets/Aqauriusss.webp"),
                  alt: "Aquarius",
                  sign: "AQUARIUS",
                  path: "/daily-horoscopeaqa",
                },
                {
                  src: require("../../assets/Piscesss.webp"),
                  alt: "Pisces",
                  sign: "PISCES",
                  path: "/daily-horoscopepis",
                },
              ].map((zodiac, index) => (
                <div
                  key={index}
                  className="sign"
                  onClick={() => navigate(zodiac.path)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="icon">
                    <img src={zodiac.src} alt={zodiac.alt} />
                  </div>
                  <h6 className="font-weight-bold text-center text-grey">
                    {zodiac.sign}
                  </h6>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div> */}
      <div className="zodiac-section">
        <div className="zodiac-section-header">
          <h2 className="zodiac-section-title">FREE DAILY HOROSCOPE</h2>
          <div className="zodiac-title-bar"></div>
        </div>
        <div className="zodiac-scroll-wrap">
          <div className="zodiac-track">
            {[
              { src: require("../../assets/Ariesss.webp"),      hi: "मेष",      en: "ARIES",       path: "/daily-horoscopeari" },
              { src: require("../../assets/Taurusss.webp"),     hi: "वृषभ",     en: "TAURUS",      path: "/daily-horoscopetau" },
              { src: require("../../assets/Geminiii.webp"),     hi: "मिथुन",    en: "GEMINI",      path: "/daily-horoscopegem" },
              { src: require("../../assets/Cancerrr.webp"),     hi: "कर्क",     en: "CANCER",      path: "/daily-horoscopecan" },
              { src: require("../../assets/Leooo.webp"),        hi: "सिंह",     en: "LEO",         path: "/daily-horoscopeleo" },
              { src: require("../../assets/Virgooo.webp"),      hi: "कन्या",    en: "VIRGO",       path: "/daily-horoscopevir" },
              { src: require("../../assets/Libraaa.webp"),      hi: "तुला",     en: "LIBRA",       path: "/daily-horoscopelib" },
              { src: require("../../assets/Scorpiooo.webp"),    hi: "वृश्चिक",  en: "SCORPIO",     path: "/daily-horoscopesco" },
              { src: require("../../assets/Sagittariusss.webp"),hi: "धनु",      en: "SAGITTARIUS", path: "/daily-horoscopesag" },
              { src: require("../../assets/Capricornnn.webp"),  hi: "मकर",      en: "CAPRICORN",   path: "/daily-horoscopecap" },
              { src: require("../../assets/Aqauriusss.webp"),   hi: "कुंभ",     en: "AQUARIUS",    path: "/daily-horoscopeaqa" },
              { src: require("../../assets/Piscesss.webp"),     hi: "मीन",      en: "PISCES",      path: "/daily-horoscopepis" },
            ].map((z, i) => (
              <div
                key={i}
                className="zodiac-item"
                onClick={() => navigate(z.path)}
              >
                <div className="zodiac-circle">
                  <img src={z.src} alt={z.en} className="zodiac-img" />
                </div>
                <p className="zodiac-hi">{z.hi}</p>
                <p className="zodiac-en">{z.en}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <AstroTipsSection />
      <PromoBanner />

       {/* <div>
        <Banner />
      </div> */}
      {/* <br></br> */}
      {/* <div>
        <Blog />
      </div> */}
      {/* <div>
        <Baner />
      </div> */}
      {/* <div>
        <Dailyhoro />
      </div> */}
      {/* <div>
        <Banneer />
      </div> */}

      <div>
        <Footer />
      </div>
    </div>
  );
};

export default App;
